__turbopack_context__.v({
  "backgroundImage": "headerSubmenu-module-scss-module__sfUDFq__backgroundImage",
  "link": "headerSubmenu-module-scss-module__sfUDFq__link",
  "menuItemLink": "headerSubmenu-module-scss-module__sfUDFq__menuItemLink",
  "number_1": "headerSubmenu-module-scss-module__sfUDFq__number_1",
  "number_2": "headerSubmenu-module-scss-module__sfUDFq__number_2",
  "number_3": "headerSubmenu-module-scss-module__sfUDFq__number_3",
  "number_4": "headerSubmenu-module-scss-module__sfUDFq__number_4",
  "number_5": "headerSubmenu-module-scss-module__sfUDFq__number_5",
  "promoItem": "headerSubmenu-module-scss-module__sfUDFq__promoItem",
  "promoItemContent": "headerSubmenu-module-scss-module__sfUDFq__promoItemContent",
  "promoItems": "headerSubmenu-module-scss-module__sfUDFq__promoItems",
  "submenu": "headerSubmenu-module-scss-module__sfUDFq__submenu",
  "submenuItem": "headerSubmenu-module-scss-module__sfUDFq__submenuItem",
  "submenuItems": "headerSubmenu-module-scss-module__sfUDFq__submenuItems",
  "submenuPart": "headerSubmenu-module-scss-module__sfUDFq__submenuPart",
  "title": "headerSubmenu-module-scss-module__sfUDFq__title",
  "wrapper": "headerSubmenu-module-scss-module__sfUDFq__wrapper",
});
